import { SERVER_URL } from '~/env';

export const MEDLY_SSO_URL = `${SERVER_URL}/api/v1/medly/sso/start`;

export const MEDLY_BANNER_LS_KEY = 'medlyBanner';

export const medlyGradientClassName =
  'bg-text-100 bg-[radial-gradient(ellipse_83%_83%_at_17%_50%,rgba(132,255,204,0.16)_0%,rgba(145,160,246,0.64)_100%)]';
